import type { IPlanningData } from 'partner360/entities/planning/model'
import { isPlanningCategoryDisabled } from 'partner360/entities/planning/model/isPlanningCategoryDisabled'

import { IFinancialPlanQualityData } from '../../../model/types'

export const filterApplicableCategories = (
  finData: IFinancialPlanQualityData[],
  settings: IPlanningData['Settings'],
  programType: string,
  sectionSettings: Record<string, unknown> = {}
) => {
  const mainCategories = new Set(
    settings
      .filter(
        (setting) =>
          setting.IsMainHierarchy === 1 && setting.ProgramType?.trim() === programType.trim()
      )
      .map(({ Category }) => Category?.trim())
      .filter(Boolean)
  )

  return finData.filter(
    ({ category }) =>
      mainCategories.has(category.trim()) && !isPlanningCategoryDisabled(category, sectionSettings)
  )
}
